<template>
  <div>
    <main class="main reception">
      <div class="section top">
        <div class="top__headline">
          <h2>본인인증 확인중입니다</h2>
        </div>
      </div>
      <div class="section call-guidance">
        <div class="call-guidance--rectangle">
          <div class="paragraph">
            <h1 class="heading">
                {{ content[index] }}
            </h1>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>
<script>
import KycService from '@/service/kyc/KycService'

export default {
  data() {
    return {
      index: 0,
      content: [
        '정보를 요청하고 있습니다',
        '잠시만 기다려 주세요',
        '확인하고 있습니다'
      ]
    }
  },
  mounted() {
    this.rotate()
  },
  async created() {
    this.$store.commit('ui/headerTitle', '본인인증 확인하기')
    await this.verification()
  },
  methods: {
    rotate() {
      setTimeout(() => {
        this.index += 1
        if (this.index >= this.content.length) {
          this.index = 0
        }
        this.rotate()
      }, 3000)
    },
    async verification() {
      try {
        let { data } = await KycService.postMobileAuthUrlResult()
        if (data) {
          await this.$router.replace({ name: 'kyc/verify-id/success' })
        } else {
          await this.$router.replace({ name: 'kyc/verify-id/fail' })
        }
      } catch (e) {
        let swal = await this.$swal.fire({
          html: '본인인증을 확인하는데 문제가 발생했습니다',
          icon: 'warning',
          confirmButtonText: '확인'
        })
        if (swal.isConfirmed) {
          this.$router.replace({ name: 'kyc/form' })
        }
        throw e
      }
    },
  }
}
</script>
<style scoped>
button[disabled] {
  color: lightgrey;
}
.heading {
  text-align: center;
}
</style>
